import {
    ADD_INCIDENCIA_MAQUINA,
    DELETE_INCIDENCIA_MAQUINA,
    MODIFY_INCIDENCIA_MAQUINA
} from '../constants/action_types';

export function addIncidenciaDeMaquina(incidencia) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_INCIDENCIA_MAQUINA, payload: incidencia });
    }
}

export function modifyIncidenciaMaquina(incidencia) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_INCIDENCIA_MAQUINA, payload: incidencia });
    }
}

export function removeIncidenciaDeMaquina(incidencia) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_INCIDENCIA_MAQUINA, payload: incidencia });
    }
}